import { render } from "./transactionHistoryComponent.vue?vue&type=template&id=381c06ae"
import script from "./transactionHistoryComponent.vue?vue&type=script&lang=js"
export * from "./transactionHistoryComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__